import { api } from '../services/api'

export interface DocumentRecord {
  type: string
  version: string
  signedAt: string
}

export interface DocumentStatusResponse {
  documents: DocumentRecord[]
}

export interface SignDocumentRequest {
  documentType: string
  documentVersion: string
  signatureData: string
}

export async function getDocumentStatus(token: string): Promise<DocumentStatusResponse> {
  const response = await fetch(`${api.baseURL}/api/documents/status`, {
    headers: { 'Authorization': `Bearer ${token}` },
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Failed to get status' }))
    throw new Error(err.error || 'Failed to get document status')
  }
  return response.json()
}

export async function signDocument(
  token: string,
  data: SignDocumentRequest
): Promise<{ success: boolean; signedAt: string }> {
  const response = await fetch(`${api.baseURL}/api/documents/sign`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Failed to sign' }))
    throw new Error(err.error || 'Failed to sign document')
  }
  return response.json()
}
